import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { EVENT_TYPES } from '../lib/analytics/constants';
import Logger from '../lib/analytics/logger';
import { setIsConnected } from '../state/actions/device';
import { setXpRequired, setXp } from '../state/slices/xp/xp';
import { setCurrentLevelBonusCoins, setLevel, setMaxBet, setNextLevelBonusCoins, setNextLevelMaxBet, setPreviousLevelBonusCoins } from '../state/slices/level/level';
import { setCoin, setLoyalty, setPremium } from '../state/actions/extras';
import { AxiosRequest } from '../state/api/services/axios';
import { store } from '../state/store';
import Utils from '../utils';
import ERROR_CODE from '../utils/errorCodes';
import AppInterface from './AppInterface';
import { ServerResponseCurrencyKeys, ServerResponseKeys } from './Constants';
import DeviceInfo from './DeviceInfo';
var currentXp = 0;
var RequestHelper = {
  /**
   * Helper method to send GET request
   * @async
   * @public
   * @param {Object} params - Body params for the fetch request
   * @param {string} params.endpoint - The endpoint for the request
   * @param {boolean} [params.logPromise] - If true, log the promise
   * @param {boolean} withExtras - Flag for handling extras
   * @returns {Object} The data object parsed from server response
   */
  apiGet: function () {
    var _apiGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(params, withExtras) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!withExtras) {
                _context.next = 4;
                break;
              }

              _context.next = 3;
              return this.apiRequestWithExtras('GET', params);

            case 3:
              return _context.abrupt("return", _context.sent);

            case 4:
              _context.next = 6;
              return this.apiRequest('GET', params);

            case 6:
              return _context.abrupt("return", _context.sent);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function apiGet(_x, _x2) {
      return _apiGet.apply(this, arguments);
    }

    return apiGet;
  }(),

  /**
   * Helper method to send POST request
   * @async
   * @public
   * @param {Object} params - Body params for the fetch request
   * @param {String} params.endpoint - The endpoint for the request
   * @param {Object} params.body - Body of the request
   * @param {boolean} [params.logPromise] - If true, log the promise
   * @param {boolean} [params.logJSON] - If true, log the full json response.
   * @param {boolean} [params.logRaw] - If true, log the raw response before attempting to parse it.
   * @param {boolean} withExtras - Flag for handling extras
   * @returns {Object} The data object parsed from server response
   */
  apiPost: function () {
    var _apiPost = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, withExtras) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!withExtras) {
                _context2.next = 4;
                break;
              }

              _context2.next = 3;
              return this.apiRequestWithExtras('POST', params);

            case 3:
              return _context2.abrupt("return", _context2.sent);

            case 4:
              _context2.next = 6;
              return this.apiRequest('POST', params);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function apiPost(_x3, _x4) {
      return _apiPost.apply(this, arguments);
    }

    return apiPost;
  }(),

  /**
   * Helper method to abstract away fetch request, with minimal error handling
   * @async
   * @private
   * @param {String} methodType - 'GET' or 'POST'
   * @param {Object} params - Body params for the fetch request
   * @param {Bool} tryRestartSession - if set to true then a failure will try to restart session
   * @returns {Object} The data object parsed from server response
   */
  apiRequest: function () {
    var _apiRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(methodType, params) {
      var requestBody, mobileParams, fetchParams, failedFetchErr, isConnected;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log("[\u2191 ".concat(methodType, " \u2191] ").concat(params.endpoint, " - ").concat(params.body ? JSON.stringify(params.body, null, 2) : 'no body'));
              requestBody = params.body;

              if (!params.isBinary) {
                mobileParams = Utils.isReactNative() && !params.baseUrl ? {
                  uid: DeviceInfo.getUID(),
                  device: DeviceInfo.getDevice(),
                  sysver: DeviceInfo.getSysVer(),
                  bundlever: DeviceInfo.getBundleVer(),
                  bundleid: DeviceInfo.getBundleId(),
                  uuid: DeviceInfo.getUID()
                } : {};
                requestBody = _objectSpread(_objectSpread({}, params.body), mobileParams);
              }

              fetchParams = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
                method: methodType,
                mode: 'cors',
                redirect: 'follow',
                referrer: 'no-referrer'
              }, params.headers && {
                headers: params.headers
              }), params.baseUrl && {
                baseURL: params.baseUrl
              }), params.ignoreCache && {
                cache: {
                  ignoreCache: params.ignoreCache
                }
              }), methodType === 'POST' && {
                data: {
                  body: requestBody,
                  raw: params.raw,
                  isBinary: params.isBinary
                }
              });
              _context3.prev = 4;
              _context3.next = 7;
              return AxiosRequest(params.endpoint, methodType, fetchParams);

            case 7:
              return _context3.abrupt("return", _context3.sent);

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](4);

              /**
               * If we receive TypeError: Failed to fetch from the fetch,
               * then we know that the call did not return
               */
              failedFetchErr = _context3.t0.toString() === 'TypeError: Failed to fetch'; // when params.baseUrl is given, it is an API call to an external resource so no need to restart session

              isConnected = store.getState().device.isConnected;

              if (!(!failedFetchErr && isConnected && !params.baseUrl)) {
                _context3.next = 18;
                break;
              }

              throw _context3.t0;

            case 18:
              if (!(isConnected && !params.shouldSkipIsConnectedCheck)) {
                _context3.next = 23;
                break;
              }

              _context3.next = 21;
              return store.dispatch(setIsConnected(false));

            case 21:
              Utils.addOnlineConnectionListener(AppInterface.initApp);
              throw 'An unexpected error has occurred, please try again later.';

            case 23:
              return _context3.abrupt("return", 'unexpected_error');

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 10]]);
    }));

    function apiRequest(_x5, _x6) {
      return _apiRequest.apply(this, arguments);
    }

    return apiRequest;
  }(),

  /**
   * A wrapper to extract misc data server sends with every response
   * @async
   * @private
   * @param {String} methodType - 'GET' or 'POST'
   * @param {Object} params - Body params for the fetch request
   * @returns {String | Object} Call response from server
   */
  apiRequestWithExtras: function () {
    var _apiRequestWithExtras = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(methodType, params) {
      var responseJson;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              this.setPreviousXp();
              _context4.next = 4;
              return this.apiRequest(methodType, params);

            case 4:
              responseJson = _context4.sent;

              if (!responseJson) {
                _context4.next = 8;
                break;
              }

              this._extrasUpdateHandler(responseJson[ServerResponseKeys.CURRENCY_BALANCES], responseJson[ServerResponseKeys.LEVEL], responseJson[ServerResponseKeys.XP], responseJson[ServerResponseKeys.DYNAMIC_SALES], responseJson[ServerResponseKeys.PROGRESSION]);

              return _context4.abrupt("return", responseJson[ServerResponseKeys.CALL_RESPONSE]);

            case 8:
              _context4.next = 14;
              break;

            case 10:
              _context4.prev = 10;
              _context4.t0 = _context4["catch"](0);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context4.t0, Object.getOwnPropertyNames(_context4.t0)),
                code: ERROR_CODE.API_REQUEST_WITH_EXTRAS_FAIL
              });
              throw _context4.t0;

            case 14:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[0, 10]]);
    }));

    function apiRequestWithExtras(_x7, _x8) {
      return _apiRequestWithExtras.apply(this, arguments);
    }

    return apiRequestWithExtras;
  }(),
  setPreviousXp: function setPreviousXp() {
    currentXp = store.getState().xpInfo.xp;
  },
  getPreviousXp: function getPreviousXp() {
    return currentXp;
  },
  getRequestBody: function getRequestBody(params) {
    var formBody = [];

    for (var property in params) {
      var encodedValue = '';

      if (typeof params[property] === 'object') {
        encodedValue = encodeURIComponent(JSON.stringify(params[property]));
      } else {
        encodedValue = encodeURIComponent(params[property]);
      }

      var encodedKey = encodeURIComponent(property);
      formBody.push("".concat(encodedKey, "=").concat(encodedValue));
    }

    formBody = formBody.join('&');
    return formBody;
  },

  /**
   * Helper method that dispatches fresh extras values from server to the redux store
   * @param {Object.<string, number>} balance
   * @param {number} level
   * @param {number} xp
   * @param {*} dynamic not sure what it might look like
   */
  _extrasUpdateHandler: function _extrasUpdateHandler(balance, level, xp, dynamic, progression) {
    try {
      console.log("[EXTRAS UPDATE] ".concat(balance, " ").concat(level, " ").concat(xp));
      store.dispatch(setCoin(parseInt(balance[ServerResponseCurrencyKeys.COINS])));
      store.dispatch(setPremium(balance[ServerResponseCurrencyKeys.PREMIUM]));
      store.dispatch(setLoyalty(parseInt(balance[ServerResponseCurrencyKeys.LOYALTY])));
      store.dispatch(setLevel(progression.level));
      store.dispatch(setXp(progression.xp));
      store.dispatch(setXpRequired(progression.xpneeded));
      store.dispatch(setMaxBet(progression.maxbet));
      store.dispatch(setNextLevelMaxBet(progression.nextLevelMaxbet));
      store.dispatch(setNextLevelBonusCoins(progression.nextLevelCoins));
      store.dispatch(setCurrentLevelBonusCoins(progression.coins));
      store.dispatch(setPreviousLevelBonusCoins(progression.previousLevelCoins));
    } catch (e) {
      console.log('_extrasUpdateHandler Error: ', e.message);
    }
    /** API doesn't actually implement this. For refreshing DTS, call ShopInterface.refreshDTS. */
    // store.dispatch(setDtsState(dynamic));

  },
  removePasswordFromRequestBody: function removePasswordFromRequestBody(body) {
    if (!body || typeof body !== 'string') {
      return '';
    }

    var findPassIndex = body.indexOf('&password');
    var newBodyString;

    if (findPassIndex >= 0) {
      newBodyString = body.substr(0, findPassIndex);
      var findSecondPart = body.indexOf('&login_type');

      if (findSecondPart > 0) {
        var secondPart = body.substr(findSecondPart);
        newBodyString = newBodyString + secondPart;
      }

      return newBodyString;
    }

    return body;
  }
};
export default RequestHelper;